var _g, _rect, _g2, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_122_3501)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.850708,
    y: 0.00012207,
    width: 42.8886,
    height: 59.5675,
    rx: 5.95675,
    fill: "#0E20BA"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_3501)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.80737,
    y: 5.9574,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "#0E20BA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_122_3501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2711 26.2322V26.7073C31.2711 29.8329 30.1709 31.8583 27.9705 32.7334L30.496 36.3591C30.8211 36.8842 30.621 37.2593 30.0209 37.2593H26.6453C26.2202 37.2593 25.9201 37.0842 25.7451 36.7592L23.5447 33.2335H18.7438V36.5091C18.7438 37.0092 18.4937 37.2593 17.9936 37.2593H15.0431C14.543 37.2593 14.2929 37.0092 14.2929 36.5091V20.3561C14.2929 19.856 14.543 19.6059 15.0431 19.6059H24.1198C28.8957 19.6059 31.2711 21.8064 31.2711 26.2322ZM23.7447 23.8567H18.7438V29.0327H23.7447C25.8701 29.0327 26.7953 28.6326 26.7953 26.6573V26.2572C26.7953 24.2818 25.9201 23.8567 23.7447 23.8567Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.731,
    height: 50.0434,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 36.9196 3.63434)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.69241,
    height: 47.1996,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 41.6635 18.3766)",
    fill: "white"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.40305,
    y: 6.55307,
    width: 29.7837,
    height: 45.2713,
    rx: 1.78702,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.19135
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_122_3501",
    x: 0.850708,
    y: -1.19123,
    width: 42.8885,
    height: 61.9502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_122_3501"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_122_3501"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_122_3501"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_122_3501",
    result: "effect2_innerShadow_122_3501"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_122_3501",
    x: 14.293,
    y: 19.606,
    width: 16.9781,
    height: 18.6533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_122_3501"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_3501"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.80737,
    y: 5.9574,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRare);
export default __webpack_public_path__ + "static/media/rare.6c34d586f9f07097c5b2b12c5e33ed6f.svg";
export { ForwardRef as ReactComponent };